import React, { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'

import Colors from 'builder/styles/colors'
import Button from 'builder/components/Button'

import ResumeBannerImg from './assets/resume-banner.png'
import { Banner } from './Banner'

const TRNSLATION = 'builder.dashboard.resume_and_coach_banners.resume_writing'

export const ResumeWritingBanner = React.memo(() => {
  const { i18n } = useI18n()
  const { features } = useFeaturesConfig()

  const text = {
    title: i18n.t(`${TRNSLATION}.title`),
    description: i18n.t(`${TRNSLATION}.description`),
    items: [
      i18n.t(`${TRNSLATION}.items.item1`),
      i18n.t(`${TRNSLATION}.items.item2`),
      i18n.t(`${TRNSLATION}.items.item3`),
    ],
  }

  const getActionLink = () => {
    const params: { [key: string]: string } = {
      pt: 'UWYxd6Xe2VTS0',
      utm_content: 'get_expert_help',
    }

    if (features?.superApp) {
      params.utm_source = 'cio'
      params.utm_medium = 'ciodash'
      params.utm_campaign = 'tr_promo_in_ciodash'
    }

    // TODO: We have to change this values when we have the new dashboard
    if (features?.international) {
      params.utm_source = 'resumeio'
      params.utm_medium = 'riodash'
      params.utm_campaign = 'tr_promo_in_riodash'
    }

    const queryParams = new URLSearchParams(params)

    return `https://topresume.com/resume-writing?${queryParams.toString()}`
  }

  const onClick = () => {
    trackInternalEvent('people_banner_cta_click', {
      type: 'resume_writing',
      cta: i18n.t(`${TRNSLATION}.action_text`),
    })
  }

  useEffect(() => {
    trackInternalEvent('see_people_banner', { type: 'resume_writing' })
  }, [])

  return (
    <Banner
      text={text}
      imageUrl={ResumeBannerImg}
      action={
        <Button as="a" target="_blank" href={getActionLink()} onClick={onClick}>
          {i18n.t(`${TRNSLATION}.action_text`)}
        </Button>
      }
      theme={{ text: Colors.Blue80, background: Colors.Blue10 }}
    />
  )
})
